/*
 * Clase para manejar reCAPTCHA v3.
 */
export default class Recaptcha {
    constructor() {
        this.siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
        this.loadScript();
    }

    async loadScript() {
        if (!document.getElementById('recaptcha-script')) {
            const script = document.createElement('script');
            script.id = 'recaptcha-script';
            script.src = `https://www.google.com/recaptcha/api.js?render=${this.siteKey}`;
            script.async = true;
            script.defer = true;
            script.setAttribute('data-badge', 'recaptcha-badge');
            document.head.appendChild(script);
        }
    }

    async execute(action) {
        return new Promise((resolve, reject) => {
            if (window.grecaptcha) {
                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute(this.siteKey, { action }).then(token => {
                        resolve(token);
                    }).catch(error => {
                        reject(error);
                    });
                });
            } else {
                reject('script reCAPTCHA no cargado');
            }
        });
    }

    showBadge() {
        //Recaptcha badge
        const badge = document.querySelector('.grecaptcha-badge');
        if (badge) {
            badge.style.visibility = 'visible';
        }
    }

    hideBadge() {
        //Recaptcha badge
        const badge = document.querySelector('.grecaptcha-badge');
        if (badge) {
            badge.style.visibility = 'hidden';
        }
    }
}